// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" id=\"flag-icon-css-ua\" viewBox=\"0 0 640 480\"> <g fill-rule=\"evenodd\" stroke-width=\"1pt\"> <path fill=\"#ffd500\" d=\"M0 0h640v480H0z\"/> <path fill=\"#005bbb\" d=\"M0 0h640v240H0z\"/> </g> </svg> ";
// Exports
module.exports = code;